import React, { useState } from "react";
import { FaCalendarAlt, FaIdCard, FaUser, FaHashtag } from "react-icons/fa";
import "./mispayment.css";

export default function CustomerReport() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // sample empty data
  const data = [];

  // search filter
  const filteredData = data.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / entriesPerPage) || 1;
  const startIndex = (currentPage - 1) * entriesPerPage;
  const currentData = filteredData.slice(startIndex, startIndex + entriesPerPage);

  function handleSearch(e) {
    e.preventDefault();
    console.log("Search payload:", {
      fromDate,
      toDate,
      accountNumber,
      customerId,
      customerName,
    });
  }

  return (
    <div className="MISPaymentcustomer-report-container">
      {/* Search Form */}
      <form className="MISPaymentsearch-form" onSubmit={handleSearch}>
        <div className="MISPaymentform-group">
          <label>
            <FaCalendarAlt /> From Date
          </label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            placeholder="dd-mm-yyyy"
          />
        </div>

        <div className="MISPaymentform-group">
          <label>
            <FaCalendarAlt /> To Date
          </label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            placeholder="dd-mm-yyyy"
          />
        </div>

        <div className="MISPaymentform-group">
          <label>
            <FaHashtag /> Account Number
          </label>
          <input
            type="text"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            placeholder="Enter Account Number"
          />
        </div>

        <div className="MISPaymentform-group">
          <label>
            <FaIdCard /> Customer ID
          </label>
          <input
            type="text"
            value={customerId}
            onChange={(e) => setCustomerId(e.target.value)}
            placeholder="Enter Customer ID"
          />
        </div>

        <div className="MISPaymentform-group full-width">
          <label>
            <FaUser /> Customer Name
          </label>
          <input
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            placeholder="Enter Customer Name"
          />
        </div>

        <div className="MISPaymentform-actions">
          <button type="submit" className="MISPaymentbtn-search">
            🔍 Search
          </button>
        </div>
      </form>

      {/* Table Section */}
      <div className="MISPaymenttable-section">
        {/* Export + Search Controls */}
        <div className="MISPaymenttable-controls">
          <div className="MISPaymentexport-buttons">
            <button className="MISPaymentbtn csv">CSV</button>
            <button className="MISPaymentbtn excel">Excel</button>
            <button className="MISPaymentbtn print">Print</button>
          </div>

          <div className="MISPaymententries-search">


               <div className="MISPaymentsearch">
                    <label>
                    Search:
               <input type="text" placeholder="Search here..." />
                 </label>
                  </div>
                     </div>

                      </div>

        {/* Data Table */}
        <div className="MISPaymenttable-container">
          <table className="MISPaymentcustomer-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Customer ID</th>
                <th>Name</th>
                <th>Account Number</th>
                <th>Period Due</th>
                <th>Interest Generated</th>
                <th>Interest Generated Since</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{startIndex + idx + 1}</td>
                    <td>{row.customerId}</td>
                    <td>{row.name}</td>
                    <td>{row.accountNumber}</td>
                    <td>{row.periodDue}</td>
                    <td>{row.interestGenerated}</td>
                    <td>{row.interestSince}</td>
                    <td>
                      <button className="MISPaymentbtn-action">View</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="MISPaymentno-data">
                        <p> No data available in table</p> 
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="MISPaymenttable-footer">
          <span>
            Showing{" "}
            {filteredData.length > 0
              ? `${startIndex + 1} to ${
                  startIndex + currentData.length
                } of ${filteredData.length}`
              : "0 to 0 of 0"}{" "}
            entries
          </span>
          <div className="MISPaymentpagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Previous
            </button>
            <button
              disabled={currentPage === totalPages || filteredData.length === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
